import React from "react";
import { Box, Content } from "react-bulma-components";

function receiptToHTML(receipt) {
  return {
    __html: receipt,
  };
}

export function displayHTMLReceipt(receipt) {
  return (
    <Box>
      <Content>
        <div
          className="html_receipt"
          dangerouslySetInnerHTML={receiptToHTML(receipt)}
        ></div>
      </Content>
    </Box>
  );
}

export default displayHTMLReceipt;
